<template>
	<dms-group label-key="Stitky" class="frmGrup_with_radius">
		<dms-select class="frmGrup_with_radius" :disabled="isAndOrDisabled" :select-list="andOrList" :value.sync="andOrCmp" label-key="AndOr" :wrapp="false"
			:clearable="false" />
		<dms-select :select-list="variaList" :value.sync="variaZktCmp" multiple label-key="Stitky" :wrapp="false" />
	</dms-group>
</template>

<script>
export default {
	props: {
		andOrList: { type: Array, required: true },
		variaList: { type: Array, required: true },
		variaZkt: { type: Array, required: true },
		andOr: { type: Boolean, required: true },
	},
	computed: {
		andOrCmp: {
			get() {
				return this.andOr;
			},
			set(val) {
				this.$emit('update:andOr', val);
			},
		},
		variaZktCmp: {
			get() {
				return this.variaZkt;
			},
			set(val) {
				this.$emit('update:variaZkt', val);
			},
		},
		isAndOrDisabled() {
			return this.variaZktCmp.length === 0;
		},
	},
};
</script>

<style>
</style>
